import { Action } from '@ngrx/store';

export function getClearErrorsType<TModel>(module: string, type: { new(): TModel; }): string {
  return `[${module}] Clear Errors for ${(type as any).$typeName}`;
}

export class ClearErrorsAction<TModel> implements Action {
  readonly type: string;

  constructor(module: string, modelType: { new(): TModel; }) {
    this.type = getClearErrorsType(module, modelType);
  }
}



// WEBPACK FOOTER //
// ./src/app/pillar/dashboard/store/actions/ClearErrorsAction.ts